import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconDiagramTree24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconDiagramTree24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M18.5 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2m0 1.5a2.5 2.5 0 1 0-2.393-3.226A3.25 3.25 0 0 0 13.25 7.5v3.75H10V7.5A2.5 2.5 0 0 0 7.5 5h-2A2.5 2.5 0 0 0 3 7.5v9A2.5 2.5 0 0 0 5.5 19h2a2.5 2.5 0 0 0 2.5-2.5v-3.75h3.25v3.75a3.25 3.25 0 0 0 3.082 3.246A2.499 2.499 0 0 0 21 18.5a2.5 2.5 0 0 0-4.98-.317 1.75 1.75 0 0 1-1.27-1.683v-3.75h1.364a2.501 2.501 0 1 0 0-1.5H14.75V7.5c0-.839.59-1.54 1.377-1.71A2.5 2.5 0 0 0 18.5 7.5m-13-1h2a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-9a1 1 0 0 1 1-1m14 5.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0m0 6.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconDiagramTree24);
